<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import Loading from '../common/Loading.svelte';
  import Error from '../common/Error.svelte';
  import TwSelectMenu from '../tailwind/TwSelectMenuCc.svelte';
  import TwCombobox from '../tailwind/TwComboboxCc.svelte';
  import TwButtonSecondary from '../tailwind/TwButtonSecondary.svelte';
  import StatisticsBatting from '../ui-components/StatisticsBatting.svelte';
  import StatisticsFielding from '../ui-components/StatisticsFielding.svelte';
  import StatisticsPitching from '../ui-components/StatisticsPitching.svelte';
  import Common from '../js/common.js';

  export let params;

  if (!Global.pages.includes('statistics')) {
    window.location.href = window.localStorage.getItem('currentPage') || './';
  }

  let lang;
  let mode;

  let statistics = [];
  let teams = [];

  const teamElements = [
    {
      value: 'all',
      label: { cs: 'Všechny týmy', en: 'All teams' },
    },
  ];

  let nameElements = [];

  let loading = true;
  let error = false;

  (async () => {
    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/statistics/get/${params.type}`);

    if (response.ok) {
      const data = await response.json();

      statistics = Common.sortArrayOfObjectsByKey(data.statistics, ['lastName', 'firstName']);
      teams = data.teams;

      teamElements.push(...Common.sortArrayOfObjectsByKey(
        teams.map(value => ({ value: value.shortcut, label: value.name, append: value.shortcut.toUpperCase() })),
        ['append'],
      ));
    } else {
      if (response.status === Common.NOT_FOUND) window.location.href = './#/statistics';
      else error = true;
    }

    loading = false;
  })();

  let team;
  let name;

  const i18n = {
    pageTitle: {
      cs: `Statistiky | ${Global.project.name.cs}`,
      en: `Statistics | ${Global.project.name.en}`,
    },
    findByTeam: {
      cs: 'Vyhledat podle týmu',
      en: 'Find by team',
    },
    findByName: {
      cs: 'Vyhledat podle jména',
      en: 'Find by name',
    },
  };

  $: nameElements = getNameElements(team);

  function getNameElements () {
    return statistics.filter(value => team === 'all' || value.team === team).map(value => ({
      value: `${value.lastName} ${value.firstName}`,
      append: value.team.toUpperCase(),
    }));
  }
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='statistics/{params.type}' display={false} savePage={false} bind:lang bind:mode/>

<div class='statistics-type'>
  <Loading bind:display={loading}/>
  <Error bind:display={error} bind:lang/>

  {#if !loading && !error}
    <div class='statistics-type-controls'>
      <div class='statistics-type-controls-find-by'>
        <div class='statistics-type-controls-find-by-team'>
          <TwSelectMenu bind:value={team} label={i18n.findByTeam[lang]} elements={teamElements} bind:lang/>
        </div>

        <div class='statistics-type-controls-find-by-name'>
          <TwCombobox bind:value={name} label={i18n.findByName[lang]} elements={nameElements}/>
        </div>
      </div>

      <div class='statistics-type-controls-back'>
        <TwButtonSecondary icon='arrow-u-turn-left' onClick={() => { window.location.href = './#/statistics'; }}/>
      </div>
    </div>

    <div class='statistics-type-content'>
      {#if params.type === 'batting'}
        <StatisticsBatting bind:value={statistics} bind:team bind:name bind:lang bind:mode/>
      {:else if params.type === 'fielding'}
        <StatisticsFielding bind:value={statistics} bind:team bind:name bind:lang bind:mode/>
      {:else if params.type === 'pitching'}
        <StatisticsPitching bind:value={statistics} bind:team bind:name bind:lang bind:mode/>
      {/if}
    </div>
  {/if}
</div>

<style>
  .statistics-type {
    display: flex;
    flex-direction: column;
    gap: 20px;

    height: calc(100vh - 40px);

    padding: 20px;
  }

  .statistics-type-controls {
    display: flex;
    align-items: flex-end;
    gap: 20px;
  }

  .statistics-type-controls-find-by {
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    gap: 20px;
  }

  .statistics-type-controls-find-by-team,
  .statistics-type-controls-find-by-name {
    width: calc((100% - 20px) / 2);
  }

  .statistics-type-content {
    height: 100%;
  }

  @media only screen and (max-width: 500px) {
    .statistics-type-controls-find-by-team,
    .statistics-type-controls-find-by-name {
      width: 100%;
    }

    .statistics-type-controls-back {
      display: none;
    }
  }
</style>
